module.exports = __webpack_public_path__ + "static/img/01.b1c103d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/01.jpg
// module id = Zj4E
// module chunks = 1